import customSelect from "@/components/common/CustomSelect/layout.vue";
import registerCardModal from "@/components/modal/RegisterCard/index.vue";
import commonPopup from "@/components/modal/commonPopup/layout.vue";
import feeList from "@/components/common/feeList.vue";
import dayjs from "@/helpers/dayjs";
import isSameofBefore from "dayjs/plugin/isSameOrBefore";
import channelTalk from "@/helpers/channelTalk";
import orderList from "./list.vue";
export default {
  props: ["orders"],
  components: {
    customSelect,
    registerCardModal,
    commonPopup,
    feeList,
    orderList
  },
  data() {
    return {
      memberType: null,
      creditId: null,
      cardList: [],
      popupMessage: null,
      popupOpen: false,
      cardModalOpen: false,
      isCard: true,
      select: null,
      totalPrice: 0,
      showDetail: false,
      gettingCard: true,
      isLoading: false
    };
  },
  watch: {
    cardList: {
      handler(val) {
        if (val.length !== 0) {
          this.select = val[0].value;
        }
      }
    }
  },
  created() {
    document.body.classList.add("modal-open");
    this.checkConfig();
    this.getTotalPrice();
    this.getCardLists();
  },
  destroyed() {
    document.body.classList.remove("modal-open");
  },

  computed: {
    options() {
      return this.cardList;
    },
    isCards() {
      return this.isCard;
    },

    creaditAvailable() {
      if (this.creditId !== null) {
        this.isCard = false;
        return true;
      }
    },

    paymentMethod() {
      const billingId = this.select;
      for (let i = 0; i < this.myCards.length; i++) {
        if (this.cardList[i].value === billingId) {
          return this.cardList[i].type;
        }
      }
      return null;
    },

    buttonStatus() {
      if (this.isCard && this.cardList.length === 0) return false;
      return true;
    }
  },

  methods: {
    /**
     * 선택한 오더의 총 가격
     */
    getTotalPrice() {
      let tPrice = 0;
      for (let i = 0; i < this.orders.length; i += 1) {
        if (this.orders[i].deliveryOptions.totalOrderFee !== undefined) {
          tPrice = this.orders[i].deliveryOptions.totalOrderFee + tPrice;
        }
      }
      this.totalPrice = tPrice;
    },
    /**
     *
     * @param {string} msg
     * alert 대체용 팝업 열기
     */
    handlePopup(msg) {
      this.popupMessage = msg;
      this.popupOpen = true;
    },
    /**
     *
     * @returns 주문 가능 여부 반환
     */
    async checkConfig() {
      const config = await this.$store.dispatch("api_get_config");
      if (config.closed === true) {
        return this.handlePopup("현재 주문접수가 마감되었습니다");
      }
    },
    /**
     * 신규카드모달 제어
     */
    closeModal() {
      this.cardModalOpen = false;
      this.getCardLists();
    },

    /**
     *
     * @returns 시간 초과된 오더 여부 반환
     */
    checkOrderPickupTime() {
      dayjs.extend(isSameofBefore);

      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].deliveryOptions.isReserved) {
          const ADD_MINUTE = 60;

          const currentMoment = dayjs().add(ADD_MINUTE, "m");
          const selectedOrderMoment = dayjs(
            `${this.orders[i].pins[0].pickupDate} ${this.orders[i].pins[0].pickupHour}:${this.orders[i].pins[0].pickupMinute}`
          );

          return !selectedOrderMoment.isSameOrBefore(currentMoment, "m");
        }
        return true;
      }
    },
    /**
     *
     * @returns 결제 요청시 사용할 payload 데이터 가공
     */
    setPayload() {
      let insertOrderList = [];
      for (let i = 0; i < this.orders.length; i++) {
        let order = this.orders[i];
        let pins = order.pins;

        for (let k = 0; k < order.pins.length; k++) {
          pins[k].coords = [
            parseFloat(pins[k].coords[0]),
            parseFloat(pins[k].coords[1])
          ];
          pins[k].pickupTime = dayjs(
            `${pins[k].pickupDate}T${pins[k].pickupHour}:${pins[k].pickupMinute}:00.00`
          );
          pins[k].pickupTime = pins[k].pickupTime.utc();
          pins[k].pickupTime =
            pins[k].pickupTime.format("YYYY-MM-DDTHH:mm:ss.00") + "Z";

          if (pins[k].addressElements) {
            pins[k].addressElements.detailAddress = pins[k].detailAddress;
          }
        }

        let finalEstimatedMinutes;
        if (order.deliveryOptions.isReserved) {
          if (order.deliveryOptions.isExpressDelivery) {
            finalEstimatedMinutes =
              order.deliveryOptions.reserveExpressEstimatedMinutes;
          } else {
            finalEstimatedMinutes =
              order.deliveryOptions.reserveEstimatedMinutes;
          }
        } else {
          if (order.deliveryOptions.isExpressDelivery) {
            finalEstimatedMinutes =
              order.deliveryOptions.expressEstimatedMinutes;
          } else {
            finalEstimatedMinutes = order.deliveryOptions.estimatedMinutes;
          }
        }

        order["item"] = {
          weight: order.deliveryOptions.weight,
          document: order.deliveryOptions.item.document.number,
          smallBox: order.deliveryOptions.item.smallBox.number,
          bigBox: order.deliveryOptions.item.bigBox.number,
          etc: order.deliveryOptions.item.etc.content,
          fragile: order.deliveryOptions.item.fragile
        };

        //백엔드 요청으로 오토바이ㅣ/승용차 제외하고 나머지 빈배열로 options 추가
        //백엔드 요청으로 다시 수정, 오토바이만 "bike", 나머지 빈배열
        if (order.deliveryOptions.vehicleCategory === 2) {
          order.options = ["bike"];
        } else {
          order.options = [];
        }

        order.clientComment = order.deliveryOptions.clientComment
          ? order.deliveryOptions.clientComment
          : "";
        order["notifiedPrice"] = order.deliveryOptions.totalOrderFee;
        order["totalDistance"] = order.deliveryOptions.totalDistance;
        order.isReserved = order.deliveryOptions.isReserved;
        order.isExpressDelivery = order.deliveryOptions.isExpressDelivery;
        order.estimatedMinutes = finalEstimatedMinutes;
        order.applicant = {
          name: order.deliveryOptions.applicant.name,
          phoneNumber: order.deliveryOptions.applicant.phoneNumber
        };
        order.clientMemo = order.deliveryOptions.clientMemo;
        order.vehicleCategory = order.deliveryOptions.vehicleCategory;
        order.vehicleType = order.deliveryOptions.vehicleType;

        if (order.deliveryOptions.vehicleCategory === 8) {
          order.vehicleOption = order.deliveryOptions.vehicleOption;
          order.loadingPosition = order.deliveryOptions.loadingPosition;
          order.unloadingPosition = order.deliveryOptions.unloadingPosition;
          order.loadingMethod = order.deliveryOptions.loadingMethod;
          order.unloadingMethod = order.deliveryOptions.unloadingMethod;
        }

        order.calcUuid = order.calcUuid;
        insertOrderList.push(order);
      }

      const payload = {
        payments: {
          billingId: this.isCard ? this.select : this.creditId
        },
        orders: insertOrderList
      };
      return payload;
    },

    /**
     *
     * 주문접수
     */
    async submitOrder() {
      this.isLoading = true;
      if (!this.checkOrderPickupTime()) {
        return this.handlePopup(
          `픽업시간이 지났거나 임박한(60분 미만) 주문이 있습니다.<br/> 픽업시간을 수정해 주세요.`
        );
      }
      const payload = await this.setPayload();
      try {
        const result = await this.$store.dispatch(
          "orders/submitOrders",
          payload
        );
        if (!result.success) {
          this.isLoading = false;
          return this.handlePopup("주문접수에 실패하였습니다");
        }
        this.$store.commit("updateCompleteOrder", result.insertedOrders);
        return this.pollingOrderStatus(result.uuid);
      } catch (e) {
        console.error(e);
        return this.handlePopup("주문접수 중 에러가 발생하였습니다");
      }
    },

    /**
     *
     * @param {string} uuid
     * uuid로 주문 접수 후 오더 상태 조회
     */
    async pollingOrderStatus(uuid) {
      let i = 0;
      const vm = this;
      const interval = setInterval(async function () {
        try {
          i++;
          const result = await vm.$store.dispatch(
            "orders/pollingOrderStatus",
            uuid
          );

          if (!result.success) {
            clearInterval(interval);
            this.isLoading = false;
            return vm.handlePopup("오류가 발생하였습니다");
          }
          if (result.status === "dropped") {
            clearInterval(interval);
            const ERROR_MSG = result.popup ? result.popup : "내부 서버 오류";
            this.isLoading = false;
            return vm.handlePopup(ERROR_MSG);
          } else if (result.status === "pending") {
          } else {
            clearInterval(interval);
            this.isLoading = false;
            vm.handlePopup(
              "주문접수가 완료되었습니다. 주문목록페이지로 이동합니다"
            );
            channelTalk.updateLastOrderAt(vm.memberType);
            vm.$emit("replaceTemporaryOrders");
            this.isLoading = false;
            return vm.$router.push("/orders/complete");
          }
        } catch (e) {
          console.error(e);
          clearInterval(interval);
          this.isLoading = false;
          return vm.handlePopup("오류가 발생하였습니다");
        }
      }, 1000);
    },

    /**
     *
     * 유저 정보 조회
     */
    async getCardLists() {
      this.cardList = [];
      let myInfo;
      try {
        myInfo = await this.$store.dispatch(
          this.$store.getters["auth/tokenPayload"]().type === "manager"
            ? "users/biz_manager_myInfo"
            : "users/biz_member_myInfo"
        );
        if (myInfo.success) {
          myInfo = myInfo.information;
          this.memberType = myInfo.memberType;
        } else {
          this.gettingCard = false;
          return this.handlePopup("회원정보를 불러오는데 실패하였습니다.");
        }
      } catch (e) {
        console.error(e);
        this.gettingCard = false;
        return this.handlePopup("회원정보를 불러오는데 실패하였습니다.");
      }

      if (this.memberType === "member") {
        if (myInfo.parentStatus && myInfo.approved === "approved") {
          await this.getParentCard();
        }
        await this.getMyCard();
        //개인카드만 가능
      } else {
        if (myInfo.approved === "approved") {
          await this.getMyCard();

          //개인카드, 월정산
        } else {
          return this.handlePopup("사용이 승인되지 않았습니다.");
        }
      }
    },

    /**
     *
     * 본인 카드 조회
     */
    async getMyCard() {
      try {
        const result = await this.$store.dispatch("payments/myCard");
        if (result.success) {
          //credit._id 있으면 월정산 사용 가능
          if (this.memberType) {
            if (result.credit && result.credit._id) {
              this.creditId = result.credit._id;
            }
          }
          this.pushMyCardList(result.cards);
        } else return this.handlePopup("카드 조회 실패하였습니다.");
      } catch (e) {
        console.error(e);
        return this.handlePopup("카드 조회 실패하였습니다.");
      }
    },

    /**
     *
     * 구성원이 관리자 카드 조회
     */
    async getParentCard() {
      try {
        const result = await this.$store.dispatch(
          "payments/getParentsBillings"
        );

        if (result.success) {
          if (result.credit && result.credit._id) {
            this.creditId = result.credit._id;
          }
          this.pushParentCardList(result.cards);
        } else {
          return this.handlePopup("에러가 발생하였습니다.");
        }
      } catch (e) {
        console.error(e);
        return this.handlePopup("에러가 발생하였습니다.");
      }
    },

    /**
     *
     * @param {Array} list
     *개인 카드 정보 저장
     */
    async pushMyCardList(list) {
      const length = list.length;
      for (let i = 0; i < length; i++) {
        this.cardList.push({
          type: "member",
          value: list[i]._id,
          title: list[i].cardInfo.cardName + list[i].cardInfo.cardNo
        });
      }
      this.gettingCard = false;
    },

    /**
     *
     * @param {Array} list
     * 관리자 태그 추가 후 관리자 카드 정보 저장
     */
    async pushParentCardList(list) {
      const length = list.length;
      for (let i = 0; i < length; i++) {
        this.cardList.push({
          type: "parent",
          value: list[i]._id,
          title:
            `<span style="
              color : #0077eb;
              border : 1px solid #dee4eb;
              font-weight: 500;
              font-size: 14px;
              line-height: 18px;
              border-radius: 4px;
              padding: 3px 8px;
              width: fit-content;
              margin-right : 12px">관리자</span>` +
            list[i].cardInfo.cardName +
            list[i].cardInfo.cardNo
        });
      }
    }
  }
};
